require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-25-kk-mr.json") })
        }
      }, "path---photos-professional-25-kk-mr");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-25-kk-mr!./.cache/json/photos-professional-25-kk-mr.json
// module id = 690
// module chunks = 231608221292675